import React from 'react';

const Success = (props) => {
  const {
    Links,
    LinksHeading,
    QuestionHeading,
    Question,
    ReplyHeading,
    Reply,
    SignatureHeading,
    Signature,
  } = props.Reply.Success;

  const links =
    Links &&
    Links.map((link, index) => (
      <li key={index}>
        <a className="c-read-reply__list__link" href={link.Url}>
          {link.Text}
        </a>
      </li>
    ));
  const titles =
    Signature.Titles &&
    Signature.Titles.map((title, index) => <span key={index}>{title}</span>);

  return (
    <section className="c-success">
      <div className="c-read-reply__answer">
        <h3>{QuestionHeading}</h3>
        <p>{Question}</p>
        <h3>{ReplyHeading}</h3>
        <div dangerouslySetInnerHTML={{ __html: Reply }}></div>

        <div className="c-read-reply__signature-container">
          <p>{SignatureHeading}</p>
          <p>{Signature.Name}</p>
          {titles}
        </div>
        {Links && (
          <div>
            <h4 className="c-read-reply__list-heading">{LinksHeading}</h4>
            <ul className="c-read-reply__list">{links}</ul>
          </div>
        )}
      </div>
    </section>
  );
};

export default Success;
